import { useMemo } from 'react';
import { MRT_ColumnDef, MRT_PaginationState } from 'material-react-table';

import { GeneralTable } from '@/shared/components/ui';
import { TABLE_CONSTANTS } from '@/shared';

export interface TablaCatalogoColumn {
  accessorKey: string;
  header: string;
  size?: number;
  Cell?: (props: { row: any }) => React.ReactNode;
}

export interface TablaCatalogoProps {
  data: any[];
  columns: TablaCatalogoColumn[];
  isLoading: boolean;
  isRefetching: boolean;
  onEdit: (item: any) => void;
  onDelete?: (item: any) => void;
  pagination: MRT_PaginationState;
  onPaging: (pagination: MRT_PaginationState) => void;
  rowCount?: number;
}

const TablaCatalogo: React.FC<TablaCatalogoProps> = ({
  data,
  columns,
  isLoading,
  isRefetching,
  onEdit,
  onDelete,
  pagination,
  onPaging,
  rowCount,
}) => {
  const tableColumns = useMemo<MRT_ColumnDef<any>[]>(
    () =>
      columns.map((col) => ({
        accessorKey: col.accessorKey,
        header: col.header,
        size: col.size ?? 180,
        ...(col.Cell && { Cell: col.Cell }),
      })),
    [columns]
  );

  return (
    <GeneralTable
      columns={tableColumns}
      data={data}
      isLoading={isLoading}
      isRefetching={isRefetching}
      enableGlobalFilter={false}
      pagination={pagination}
      onPaging={onPaging}
      rowCount={rowCount ?? data.length}
      actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
      enableColumnActions={true}
      enableEditing={true}
      enableSorting={false}
      canEdit={true}
      onEdit={onEdit}
      canDelete={!!onDelete}
      onDelete={onDelete}
      density="comfortable"
    />
  );
};

export default TablaCatalogo;
